export default {
	items: [],
	timeline: "one_year",
	holding_type:"all",
	is_history:true,
}